import {
  CHANGE_STATION_STATUS,
  CREATE_CHARGING_STATION,
  DELETE_CHARGING_STATION,
  FETCH_CHARGING_STATION,
  GET_CHARGING_STATION,
  UPDATE_CHARGING_STATION,
  UPDATE_CONTACT_PERSON,
  GET_STATION_WIDGETS,
} from 'actions/chargingStation';
import * as _ from 'lodash';
import { toast } from 'react-toastify';

const initialState = {
  isLoading: false,
  chargingStations: [],
  chargingStationDetail: {},
};

const chargingStationReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_CHARGING_STATION.REQUEST:
    case CREATE_CHARGING_STATION.REQUEST:
    case GET_CHARGING_STATION.REQUEST:
    case DELETE_CHARGING_STATION.REQUEST:
    case UPDATE_CHARGING_STATION.REQUEST:
    case CHANGE_STATION_STATUS.REQUEST:
    case UPDATE_CONTACT_PERSON.REQUEST:
    case GET_STATION_WIDGETS.REQUEST: {
      return { ...state, isLoading: true };
    }

    case FETCH_CHARGING_STATION.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        chargingStations: payload,
      };
    }

    case GET_STATION_WIDGETS.SUCCESS: {
      return {
        ...state,
        chargingStations: payload,
        available: payload.data?.availableCount,
        unavailable: payload.data?.unavailableCount,
        comingsoon: payload.data?.comingSoonCount,
        powerLoss: payload.data?.powerLossCount,
        inUse: payload.data?.inuseCount,
        underMaintenance: payload.data?.undermntnCount,
        totalCsCount: payload.data?.totalCount,
      };
    }

    case CREATE_CHARGING_STATION.SUCCESS: {
      toast.success('Station added successfully');
      // window.location.href = '/stations';
      return {
        ...state,
        chargingStations: _.concat(state.chargingStations, payload),
        isLoading: false,
      };
    }

    case GET_CHARGING_STATION.SUCCESS: {
      return {
        ...state,
        chargingStationDetail: payload,
        isLoading: false,
      };
    }

    case DELETE_CHARGING_STATION.SUCCESS: {
      toast.success('Station deleted successfully');
      // window.location.href = '/stations';
      return {
        ...state,
        chargingStations: state.chargingStations.filter((data) => data.id !== payload),
      };
    }

    case UPDATE_CONTACT_PERSON.SUCCESS: {
      toast.success('Contact Person updated Successfully');
      return {
        ...state,
        chargingStationDetail: { ...state.chargingStationDetail, contact_person: { ...state.chargingStationDetail.contact_person, ...payload } },
      };
    }

    case UPDATE_CHARGING_STATION.SUCCESS: {
      toast.success('Station updated successfully');
      // setTimeout(() => {
      // window.location.href = `/stations/${payload.id}`;
      // }, 1000);
      return {
        ...state,
        chargingStationDetail: payload,
        chargingStations: state.chargingStations.map((data) => (data.id === payload.id ? payload : data)),
        isLoading: false,
      };
    }

    case CHANGE_STATION_STATUS.SUCCESS: {
      toast.success(`Station ${payload.is_enabled === true ? 'Enabled' : 'Disabled'} successfully`);
      return {
        ...state,
        chargingStationDetail: { ...state.chargingStationDetail, is_enabled: payload.is_enabled },
        isLoading: false,
      };
    }

    case FETCH_CHARGING_STATION.FAIL:
    case CREATE_CHARGING_STATION.FAIL:
    case GET_CHARGING_STATION.FAIL:
    case DELETE_CHARGING_STATION.FAIL:
    case UPDATE_CHARGING_STATION.FAIL:
    case CHANGE_STATION_STATUS.FAIL:
    case UPDATE_CONTACT_PERSON.FAIL:
    case GET_STATION_WIDGETS.FAIL: {
      return { ...state, isLoading: false };
    }

    default:
      return { ...state };
  }
};
export default chargingStationReducer;
